import React, {useRef} from 'react';
import {PtrnAccionButtonProps} from './PtrnAccionButtonTypes';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import PatronIcon from '../PtrnIcon';
import {getBotonPersonalizacion} from './PtrnAccionButtonUtils';
import {PtrnBotonPosicion} from '../../patronTypes';

function PtrnAccionButton({
   accion,
   camposData,
   ptrnRef,
   posicionIcono,
   color,
   title,
   index,
   campoConfig,
   disabled,
   size,
   ruta,
   fullWidth,
   style
}: PtrnAccionButtonProps) {
   const buttonRef = useRef(null);

   function handleOnClick() {
      accion.fn(camposData!, {ptrnRef, componenteRef: buttonRef, index, campoConfig, ruta});
   }

   const personalizar = getBotonPersonalizacion(accion.tipo, color);
   const hasLabel = !!accion.label;
   const hasIcon = !!accion.icon;

   const Icon = hasIcon ? (
      <PatronIcon
         icon={accion.icon}
         fontSize={size || 'large'}
         style={{
            padding: hasLabel ? undefined : 0
         }}
      />
   ) : null;

   if (!hasLabel && hasIcon) {
      return (
         <IconButton
            ref={buttonRef}
            onClick={handleOnClick}
            title={title}
            color={personalizar.color}
            disabled={disabled}
            sx={{
               display: 'flex',
               justifyContent: 'center',
               alignItems: 'center',
               minWidth: 0,
               p: 1
            }}
            style={style}
         >
            {Icon}
         </IconButton>
      );
   }

   // 🔹 Si tiene label o no tiene icono → renderiza Button normal
   return (
      <Button
         sx={{
            textTransform: 'none',
            minWidth: 0,
            p: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
         }}
         ref={buttonRef}
         onClick={handleOnClick}
         title={accion.descripcion}
         startIcon={hasLabel && posicionIcono === PtrnBotonPosicion.inicio ? Icon : undefined}
         endIcon={hasLabel && posicionIcono === PtrnBotonPosicion.fin ? Icon : undefined}
         variant={personalizar.variant}
         color={personalizar.color}
         disabled={disabled}
         size={size || 'large'}
         fullWidth={fullWidth}
         style={style}
      >
         {accion.label || Icon}
      </Button>
   );
}

export default PtrnAccionButton;
